class r {
  constructor() {
    this.decimalSeparator = ",";
  }
  zipcode(a) {
    return !!a.match(/^[1-7]((0[1-9])|(1[0-9])|(20))((0[1-9])|(1[0-6]))$/i);
  }
}
export {
  r as default
};
